import React from 'react';
import { Segment, MentionSource } from '@frontend/gql/social/graphql';
import { FilterIcon } from '@revfluence/fresh-icons/solid';
import { ProjectBadges } from './project-badges';
import { GroupBadges } from './group-badges';
import { NetworkBadges } from './network-badges';
import { PostTypeBadges } from './post-type-badges';
import { IncludeEstimatesBadge } from './include-estimates-badge';
import { SegmentBadge } from './segment-badge';
import { MentionSourceBadge } from './mention-source-badge';
import { MemberBadges } from './member-badges';
import { DateFilterMethodBadge } from './date-filter-method-badge';
// import { IncludeUnassignedBadge } from './include-unassigned-badge';
import { Project, Group, Member } from '../filters-form/types';
import { NetworkValue, PostTypeValue } from '../filters-form';
import { DismissableBadge } from '../../../components/filters/badges/dismissable-badge';

interface SocialAnalyticsFilterBadgesProps {
  isDefaultVariables: boolean;
  projectBadgesProps: {
    data: Project[];
  };
  groupBadgesProps: {
    data: Group[];
  };
  networkBadgesProps: {
    data: { value: NetworkValue; label: string }[];
  };
  postTypeBadgesProps: {
    data: { value: PostTypeValue; label: string }[];
  };
  includeEstimatesBadgeProps: {
    data: { value: string; label: string }[];
  };
  segmentBadgeProps: {
    segments: Segment[] | null | undefined;
  };
  mentionSourceBadgeProps: {
    mentionSources: MentionSource[] | null | undefined;
  };
  memberBadgesProps: {
    data: Member[];
  };
  dateFilterMethodBadgeProps: {
    data: { value: string; label: string; description?: string }[];
  };
  // includeUnassignedBadgeProps: {
  //   data: { value: string; label: string; }[];
  // };
  onOpenFilters: () => void;
  onRemoveFilters: (type: string) => (event: React.MouseEvent<HTMLButtonElement>) => void;
}

export const SocialAnalyticsFilterBadges: React.FC<SocialAnalyticsFilterBadgesProps> = ({
  projectBadgesProps,
  groupBadgesProps,
  networkBadgesProps,
  postTypeBadgesProps,
  includeEstimatesBadgeProps,
  segmentBadgeProps,
  mentionSourceBadgeProps,
  isDefaultVariables,
  memberBadgesProps,
  dateFilterMethodBadgeProps,
  // includeUnassignedBadgeProps,
  onOpenFilters,
  onRemoveFilters,
}) => {
  return isDefaultVariables ?
    (
      <DismissableBadge
        variant="secondary"
        className="mr-2 mb-2"
        aria-label="Filters"
        role="button"
        data-dd-action-name="open-analytics-filters"
        onClick={onOpenFilters}
      >
        <FilterIcon className="mr-2" />Filters
      </DismissableBadge>
    )
  : (
    <>
      <ProjectBadges {...projectBadgesProps} onClick={onOpenFilters} onDismiss={onRemoveFilters('projectIds')} />
      <GroupBadges {...groupBadgesProps} onClick={onOpenFilters} onDismiss={onRemoveFilters('groupIds')} />
      <NetworkBadges {...networkBadgesProps} onClick={onOpenFilters} onDismiss={onRemoveFilters('networks')} />
      <PostTypeBadges {...postTypeBadgesProps} onClick={onOpenFilters} onDismiss={onRemoveFilters('postTypes')} />
      <IncludeEstimatesBadge
        {...includeEstimatesBadgeProps}
        onClick={onOpenFilters}
        onDismiss={onRemoveFilters('includeEstimates')}
      />
      <DateFilterMethodBadge
        {...dateFilterMethodBadgeProps}
        onClick={onOpenFilters}
        onDismiss={onRemoveFilters('dateFilterMethod')}
      />
      <SegmentBadge {...segmentBadgeProps} onClick={onOpenFilters} onDismiss={onRemoveFilters('segments')} />
      <MentionSourceBadge {...mentionSourceBadgeProps} onClick={onOpenFilters} onDismiss={onRemoveFilters('mentionSources')} />
      <MemberBadges {...memberBadgesProps} onClick={onOpenFilters} onDismiss={onRemoveFilters('memberIds')} />
      {/* <IncludeUnassignedBadge
        {...includeUnassignedBadgeProps}
        onClick={onOpenFilters}
        onDismiss={onRemoveFilters('includeUnassigned')}
      /> */}
    </>
  );
};

SocialAnalyticsFilterBadges.displayName = 'SocialAnalyticsFilterBadges';
